import get from 'lodash/get';
import {
  invalidCardNumberErrorText,
  invalidCvvErrorText,
  invalidCardDateErrorText,
  invalidPostalCodeErrorText,
} from '../form/paymentValidation';

const standardErrors = {
  number: invalidCardNumberErrorText,
  cvv: invalidCvvErrorText,
  month: invalidCardDateErrorText,
  year: invalidCardDateErrorText,
  postal_code: invalidPostalCodeErrorText,
};

/**
 * Responsible for standardizing any error generated by the recurly.token call by mapping
 * the invalid field names to our internal error messages.
 *
 * Documentation: Tokenization errors: https://dev.recurly.com/docs/recurly-js-errors#section-tokenization
 *
 * @param recurlyError {object}:
 *  RecurlyError {
 *    code: 'validation',
 *    fields: ['number', 'cvv', 'month', 'year'],
 *    message: 'There was an error validating your request.'
 *    name: 'validation',
 *  }
 * @returns {Error}
 */
export default function standardizeRecurlyError(recurlyError) {
  const fields = get(recurlyError, 'fields', []);
  const fieldName = fields[0];
  if (!fieldName) {
    // Return an error without a message so that error handling in PaymentForm uses
    // default error message.
    return new Error();
  }
  const standardError = standardErrors[fieldName];
  return new Error(standardError);
}
